var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('LoginActionButton',{class:_vm.$style.actionButton,attrs:{"action":_vm.handleSubmit,"disabled":_vm.isLoading}},[_c('span',{class:_vm.$style.textContainer},[(_vm.isLoading)?_c('LoadingIcon',{class:_vm.$style.loadingIconContainer}):_vm._e(),_vm._v("\n    "+_vm._s(_vm.buttonText)+"\n  ")],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }